export const outer = {
  width: '100%',
  height: '100%',
  paddingTop: 14,
  overflowX: 'hidden' as const,
  overflowY: 'auto' as const,
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  display: 'flex',
  flex: 1,
};

export const outerStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  minHeight: '100vh',
  alignItems: 'center',
  justifyContent: 'center',
  margin: 0,
  padding: 0,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 0,
};

export const leftColumn = {
  flex: '1 1 0',
  flexDirection: 'column' as const,
  justifyContent: 'flex-start',
  alignItems: 'center',
  display: 'flex',
  paddingBottom: 'calc(var(--report-widget-height, 0px) + var(--footer-height, 0px) + 16px)',
  boxSizing: 'border-box' as const,
};
export const storeHeader = {
  width: '100%',
  height: '100%',
  flexDirection: 'column' as const,
  justifyContent: 'center',
  alignItems: 'center',
  gap: 24,
  display: 'inline-flex',
};

export const storeHeaderTitle = {
  color: '#2E2E2E',
  fontSize: 24,
  margin: '2dvh auto 4.5dvh auto',
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 500,
  textTransform: 'capitalize' as const,
  wordWrap: 'break-word'
}

export const cardsWrap = {
  alignSelf: 'stretch',
  paddingTop: 32,
  paddingBottom: 40,
  paddingLeft: 24,
  paddingRight: 24,
  background: 'url("https://rescloud.ediblearrangements.com/image/upload/v1745436628/Creative-Marketing/site_support/banners/hero/5.5_Desktop_mday-v2.webp") center/cover no-repeat',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: 32,
  display: 'flex',
  flexWrap: 'nowrap' as const,
  overflowX: 'scroll' as const,
  overflowY: 'hidden' as const,
  width: '100%',
  maxWidth: '100vw',
  minWidth: 0,
};

export const cardsWrapGrid = {
  alignSelf: 'stretch',
  paddingTop: 32,
  paddingBottom: 40,
  paddingLeft: 0,
  paddingRight: 24,
  background: 'url("https://rescloud.ediblearrangements.com/image/upload/v1745436628/Creative-Marketing/site_support/banners/hero/5.5_Desktop_mday-v2.webp") center/cover no-repeat',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: 32,
  display: 'inline-flex',
  flexWrap: 'wrap' as const,
  alignContent: 'flex-start',
  minHeight: 240,
};

export const comingSoonTitle: React.CSSProperties = {
  color: '#2E2E2E',
  fontSize: 24,
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 500,
  textTransform: 'capitalize' as const,
  wordWrap: 'break-word' as const,
  padding: '32px 24px 5px',
  alignSelf: 'flex-start',
  margin: 'auto 20px',
};

export const card: React.CSSProperties = {
  width: 240,
  height: 216,
  background: 'white',
  boxShadow: '0px 7px 15px rgba(0, 0, 0, 0.16)',
  borderRadius: 8,
  justifyContent: 'center',
  alignItems: 'center',
  gap: 32,
  display: 'flex',
  flex: '0 0 auto',
  flexDirection: 'column' as const,
  position: 'relative',
};

export const cardInner = {
  paddingLeft: 24,
  paddingRight: 24,
  paddingTop: 32,
  paddingBottom: 32,
  alignSelf: 'stretch',
  flexDirection: 'column' as const,
  justifyContent: 'flex-start',
  alignItems: 'stretch',
  gap: 12,
  display: 'flex',
};

export const cardImage = {
  alignSelf: 'stretch',
  height: 131,
  padding: 124.5,
  borderRadius: 5,
  objectFit: 'cover' as const,
};

export const cardTitleWrap: React.CSSProperties = {
  alignSelf: 'stretch',
  flexDirection: 'column' as const,
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: 8,
  display: 'flex',
  textAlign: 'center'
};

export const cardTitle = {
  color: 'black',
  fontSize: 18,
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 500,
  textTransform: 'capitalize' as const,
  wordWrap: 'break-word' as const,
};

export const cardBadge: React.CSSProperties = {
  position: 'absolute',
  top: 10,
  right: 10,
  minWidth: 20,
  height: 20,
  padding: '0 6px',
  background: '#E10600',
  color: '#FFFFFF',
  borderRadius: 999,
  fontFamily: 'Poppins, sans-serif',
  fontSize: 12,
  fontWeight: 600,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.2)',
  willChange: 'box-shadow',
};

export const reportTileWrap: React.CSSProperties = {
  position: 'fixed',
  left: 16,
  right: 16,
  bottom: 'calc(var(--footer-height, 70px) + 8px)',
  width: 'calc(100vw - 32px)',
  zIndex: 20,
  display: 'flex',
  justifyContent: 'center',
};

export const reportTile: React.CSSProperties = {
  width: '100%',
  background: 'white',
  boxShadow: '0px 7px 15px rgba(0, 0, 0, 0.16)',
  borderRadius: 12,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
};

export const reportTileHeader: React.CSSProperties = {
  padding: '10px 16px',
  fontFamily: 'Poppins, sans-serif',
  fontSize: 16,
  fontWeight: 600,
  color: '#FFFFFF',
  background: '#E10600',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const reportTileHeaderClickable: React.CSSProperties = {
  cursor: 'pointer',
};

export const reportTileToggle: React.CSSProperties = {
  fontFamily: 'Poppins, sans-serif',
  fontSize: 12,
  fontWeight: 600,
  color: '#FFFFFF',
  background: 'rgba(255, 255, 255, 0.15)',
  border: '1px solid rgba(255, 255, 255, 0.4)',
  borderRadius: 999,
  padding: '3px 10px',
  cursor: 'pointer',
};

export const reportTileHeaderDate: React.CSSProperties = {
  fontFamily: 'Poppins, sans-serif',
  fontSize: 13,
  fontWeight: 500,
  color: '#FFFFFF',
  background: 'transparent',
  border: '1px solid rgba(255, 255, 255, 0.7)',
  borderRadius: 6,
  padding: '4px 8px',
  outline: 'none',
  colorScheme: 'dark',
};

export const reportTileHeaderActions: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
};

export const reportTileHeaderButton: React.CSSProperties = {
  fontFamily: 'Poppins, sans-serif',
  fontSize: 12,
  fontWeight: 500,
  color: '#FFFFFF',
  background: 'transparent',
  border: '1px solid rgba(255, 255, 255, 0.7)',
  borderRadius: 6,
  padding: '4px 10px',
  cursor: 'pointer',
};

export const reportPanels: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'stretch',
  gap: 16,
  flexWrap: 'wrap',
  padding: '12px 16px 16px',
  background: '#FFFFFF',
};

export const reportPanelsCollapsed: React.CSSProperties = {
  maxHeight: 0,
  opacity: 0,
  overflow: 'hidden',
  paddingTop: 0,
  paddingBottom: 0,
  pointerEvents: 'none',
  transition: 'max-height 0.25s ease, opacity 0.2s ease',
};

export const reportPanelsExpanded: React.CSSProperties = {
  maxHeight: 800,
  opacity: 1,
  padding: '12px 20px',
  transition: 'max-height 0.35s ease, opacity 0.25s ease',
};

export const reportPanel: React.CSSProperties = {
  border: '1px solid #ECECEC',
  borderRadius: 10,
  padding: '12px',
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
  flex: '1 1 320px',
  minWidth: 280,
};

export const reportPanelTitle: React.CSSProperties = {
  fontFamily: 'Poppins, sans-serif',
  fontSize: 13,
  fontWeight: 600,
  color: '#2E2E2E',
};

export const reportPanelHeader: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
};

export const reportPanelDate: React.CSSProperties = {
  fontFamily: 'Poppins, sans-serif',
  fontSize: 12,
  fontWeight: 500,
  color: '#2E2E2E',
  background: 'transparent',
  border: '1px solid #D2D2D2',
  borderRadius: 6,
  padding: '3px 6px',
  outline: 'none',
};

export const reportPanelButton: React.CSSProperties = {
  fontFamily: 'Poppins, sans-serif',
  fontSize: 12,
  fontWeight: 500,
  color: '#2E2E2E',
  background: 'transparent',
  border: '1px solid #D2D2D2',
  borderRadius: 6,
  padding: '3px 8px',
  cursor: 'pointer',
};

export const reportMetricRow: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  fontFamily: 'Poppins, sans-serif',
  fontSize: 13,
  color: '#2E2E2E',
};


export const reportSection: React.CSSProperties = {
  padding: '16px 20px',
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
};

export const reportRow: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  fontFamily: 'Poppins, sans-serif',
  fontSize: 14,
  color: '#2E2E2E',
};

export const reportRowValueMuted: React.CSSProperties = {
  color: '#7A7A7A',
  fontWeight: 400,
  fontSize: 13,
};

export const reportProgressTrack: React.CSSProperties = {
  height: 8,
  background: '#D9D9D9',
  borderRadius: 999,
  overflow: 'hidden',
};

export const reportProgressFill: React.CSSProperties = {
  height: '100%',
  borderRadius: 999,
  background: '#2E7DF6',
};

export const reportList: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  padding: '12px 20px',
  borderTop: '1px solid #ECECEC',
};

export const reportListRow: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '12px',
  fontFamily: 'Poppins, sans-serif',
  fontSize: 14,
  color: '#2E2E2E',
  borderBottom: '1px solid #ECECEC',
};

export const reportEmptyState: React.CSSProperties = {
  padding: '8px 20px 16px',
  fontFamily: 'Poppins, sans-serif',
  fontSize: 13,
  color: '#7A7A7A',
};
